import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { useCallback } from "react";
import { IAddNodeFileRequest } from "api/models/request/IAddNodeFileRequest";
import { AxiosProgressEvent } from "axios";
import { FileFlat } from "models/FileFlat";
import { NodeFileType } from "models/NodeFileType";
import { addNodeFile } from "api/services/node-service";

export const useAddNodeFile = (nodeFileType: NodeFileType) => {
    const { callAPI, loading } = useWorkspaceApiCall<IAddNodeFileRequest, FileFlat>(addNodeFile, '', '');

    const uploadNodeFile = useCallback(async (
        file: File,
        group: string | null,
        onStart: () => void,
        onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
        onUploaded: (success: boolean) => void
    ) => {
        let formData = new FormData();
        formData.append("file", file);
        if (group) formData.append("group", group);

        onStart();

        const response = await callAPI({
            formData: formData,
            fileName: file.name,
            onUploadProgress,
            nodeFileType
        });

        onUploaded(response != null && response.success);

        return response;
    }, [callAPI, nodeFileType]);

    return { uploadNodeFile, isLoading: loading };
}
